// Textos del cotizador: renglones del producto y el estado sin plan de crédito.
import type { CatalogItem } from '@/domains/sales/wizard/types';
import { formatMXN } from '@/shared/lib/format/money';
import { productTierLabel } from '@/shared/lib/format/productTier';
import { PENDING_CELL } from '../../customers/lib/customersFormat';
import { variantLabel } from '@/shared/lib/format/capacity';

/** Título del estado vacío cuando el vendedor no tiene un plan de crédito para simular. */
export const NO_CREDIT_PLAN = 'Sin plan de crédito disponible';

/** Explicación corta del estado vacío, bajo el título del hero. */
export const NO_CREDIT_PLAN_HINT =
    'Las cuotas aparecen cuando tu tienda tenga un plan de crédito para cotizar.';

/** Casillas vacías del grid de plazos y del comparador: una fila de 3, como el mock. */
export const EMPTY_TERM_SLOTS = 3;

/** «1 disponible» / «N disponibles»; sin dato cuenta cero. */
export function stockLabel(stock: number | null | undefined): string {
    const count = stock ?? 0;
    return `${String(count)} ${count === 1 ? 'disponible' : 'disponibles'}`;
}

/** Gama, variante y piezas: la línea que distingue dos equipos del mismo modelo. */
export function productMeta(item: CatalogItem): string {
    const variant = variantLabel(item);
    return [productTierLabel(item.tier), variant, stockLabel(item.stock)]
        .filter((part) => part !== '' && part !== PENDING_CELL)
        .join(' · ');
}

/** Lo que sigue al nombre bajo el buscador; omite la gama si el producto no la trae. */
export function productInfoLine(item: CatalogItem): string {
    const tier = productTierLabel(item.tier);
    const parts = [
        tier === PENDING_CELL ? '' : tier.toLowerCase(),
        `disp. ${String(item.stock ?? 0)}`,
        `precio ${formatMXN(item.cashPriceCents / 100)}`,
    ].filter((part) => part !== '');
    return parts.map((part) => ` · ${part}`).join('');
}
